import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        primary: '#EBAE2D',
        secondary: '#4C3F39',
        accent: '#8c9eff',
        error: '#b71c1c'
      },
    },
  }
});